import styled from '@emotion/styled';
import { mq } from './breakpoints';
import { ZIndex } from './z-index';
import { ThemeProps } from '@theme/base';

export enum SectionTitleSizes {
  LARGE = 'LARGE',
  REGULAR = 'REGULAR'
}

interface ComponentContainerProps extends ThemeProps {
  isEdgeToEdge: boolean;
  noPadding: boolean;
}
export const ComponentContainer: any = styled.article(
  ({ theme, isEdgeToEdge, noPadding }: ComponentContainerProps) => ({
    padding: !isEdgeToEdge && !noPadding ? `0 ${theme.custom.spacing.large}px` : 0,
    margin: '0 auto',
    ...(!isEdgeToEdge && {
      maxWidth: theme.custom.contentSizes.maxContentWidth
    })
  })
);

export const Component: any = styled.div(({ theme, isEdgeToEdge, noPadding }: ComponentContainerProps) => ({
  padding: !isEdgeToEdge && !noPadding ? `0 ${theme.custom.spacing.large}px` : 0,
  margin: '0 auto',
  ...(!isEdgeToEdge && {
    maxWidth: theme.custom.contentSizes.maxContentWidth
  })
}));

interface HeaderContainerProps extends ThemeProps {
  isOverlay?: boolean;
}
export const HeaderContainer: any = styled.nav(({ theme, isOverlay }: HeaderContainerProps) => ({
  position: isOverlay ? 'absolute' : 'relative',
  width: '100%',
  color: theme.custom.colors.black,
  background: isOverlay
    ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.3) 10%, rgba(255, 255, 255, 0) 100%)'
    : theme.custom.colors.group2.dark,
  zIndex: ZIndex.NAVIGATION,
  ...(isOverlay && {
    height: 150
  })
}));

export const NavBarContainer = styled.div({
  position: 'relative'
});

interface NavBarWrapperProps extends ThemeProps {
  fullWidth: boolean;
}
export const NavBarWrapper: any = styled.div(({ theme, fullWidth }: NavBarWrapperProps) => ({
  padding: theme.custom.spacing.medium,
  [mq.small]: {
    marginBottom: 0,
    boxShadow: 'none'
  },
  [mq.large]: {
    padding: fullWidth ? `${theme.custom.spacing.medium}px 3%` : theme.custom.spacing.medium
  },
  ...(!fullWidth &&
    ({
      maxWidth: theme.custom.contentSizes.maxContentWidth,
      marginLeft: 'auto',
      marginRight: 'auto'
    } as any))
}));

export const SectionContainer = styled.div(({ theme }: ThemeProps) => ({
  backgroundColor: theme.custom.colors.group10.lighter,
  borderBottom: `1px solid ${theme.custom.colors.group10.light}`,
  borderTop: `1px solid ${theme.custom.colors.group10.light}`
}));

interface SectionSeparatorProps extends ThemeProps {
  size?: number;
}
export const SectionSeparator: any = styled.div(({ theme, size }: SectionSeparatorProps) => ({
  height: typeof size === 'undefined' ? theme.custom.spacing.xxLarge : size,
  [mq.medium]: {
    height: size || theme.custom.spacing.xxxLarge
  }
}));

interface CMSSeparatorProps {
  height: string;
}
export const CMSSeparator: any = styled.div(({ height }: CMSSeparatorProps) => ({
  height: `${height}px`
}));

interface SeparatorProps extends ThemeProps {
  value: string;
}
export const Separator: any = styled('div', { shouldForwardProp: () => false })(({ theme, value }: SeparatorProps) => ({
  height: `${value === theme.custom.spacing.xxxLarge.toString() ? Number(value) / 2 : value}px`,
  [mq.small]: {
    height: `${value}px`
  }
}));

interface LineSeparatorProps extends ThemeProps {
  color?: string;
}
export const LineSeparator: any = styled.div(({ theme, color }: LineSeparatorProps) => ({
  borderBottom: `1px solid ${color || theme.custom.colors.group10.lighter}`
}));
